<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel"
           :width="650"
    >
      <h3 slot="header" class="modal-header">快捷配置</h3>
      <div class="inline-b">
        <span class="label">所属应用：</span>
        <Select v-model="appType" @on-change="changeAppType" class="item-width">
          <Option v-for="item in appTypeList" :value="item.value" :key="'keyC'+item.value">{{item.text}}</Option>
        </Select>
      </div>
      <div class="flex  content">
        <div class="flexnone left">
          <Input  class="mb16" placeholder="搜索" @on-change="setTreeData"
                  v-model="searchText"/>
          <Tree :data="treeData"   :multiple="true" show-checkbox > </Tree>
        </div>
        <div class="flexauto right">
          <Table  ref="selection" :columns="columns"
                  :data="dataTable"
                  :height="380"
                  @on-selection-change="selectItem"
          ></Table>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {addRolePermission, rolecopyRolelist} from "../../../../api/character";
  import {filterArr,setTitleAndOthers} from "../../js/systemmanage";
  import {menuTree} from "../../../../api/menu";
  import {copyRolePermission,rolelist} from "../../../../api/character";
  import {deepClone} from "../../../../utils/format";


  export default {
    name: ""   ,
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },

    },
    watch:{
      n(){
        this.clearData()
        this.rolecopyRolelist()
        this.menuTree()
        this.isShow=true

      }
    },
    data(){

      return {
        selected:[],
        appType:3,
        treeData:[],
        searchText:'',
        dataTable:[],
        appTypeList:[{text:'自如寓后台',value:1},{text:'超级ZO',value:2},{text:'一三环境',value:3}],
        columns:[
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '机构名称',
            key: 'orgName',
            align:'center'
          },
          {
            title: '所属应用',
            key: 'isZyuName',
            align:'center',
            // render:(h,params)=>{
            //   return h('span',{},params.row['isZyu']==='1'?'自如寓':'超级ZO')
            // }
          },
          {
            title: '角色名称',
            key: 'roleName',
            align:'center'
          },
        ],
        loading: true,
        isShow:false,
        data: [],
      }
    },
    methods:{
      setPermIds() {
        if(!this.data.length){
          return []
        }
        let arrCheck = []

        function dealArr(arr,parent) {
          arr.forEach(ele=>{
            let parenEle=deepClone(parent)
            if(ele.children && ele.children.length){
              parenEle.push(ele.parentValue);
              parenEle.push(ele.value)
              dealArr(ele.children,parenEle)
            }
            if (!ele.children || ele.children.length === 0) {
              if(ele.checked){
                parenEle.push(ele.value);
                arrCheck = arrCheck.concat(parenEle)
              }
            }

          })
        }
        dealArr(this.data,[])

        let  res =[];
        let  json = {};
        for(let  i=0;i<arrCheck.length;i++){
          if(!json[arrCheck[i]]){

            res.push(arrCheck[i]);

            json[arrCheck[i]] = 1;
          }
        }
        return res

      },
      menuTree() {
        if(!this.appType){
          return
        }
        menuTree({appType:this.appType}).then(res => {
          if (!res.data) {
            return
          }
          setTitleAndOthers(res.data)
          this.data = res.data
          this.setTreeData()
        }).catch(error => {
        })
      },
      clearData(){
        this.searchText=''
        this.dataTable=[]
        this.data=[]
        this.treeData=[]
        this.selected=[]
      },

      selectItem(value){
        this.selected=value
      },
      setTreeData: function () {
        if (!this.searchText) {
          this.treeData = this.data
        }
        else {
          this.treeData = filterArr(this.data, this.searchText)
        }
      },
      rolecopyRolelist(){
        if(!this.appType){
          return
        }
        let params={
          appType:this.appType,
          page:1,
          limit:100
        }
        rolelist(params).then(res=>{
          if(!res.data){
            return
          }
          this.dataTable=res.data.rows
        }).catch(error=>{})
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      changeAppType(){
        this.rolecopyRolelist()
        this.menuTree()
      },
      ok(){
        let permIds=this.setPermIds()
        let roleArr=[]
        this.selected.forEach(ele=>{
          roleArr.push(ele.id)
        })

        if(permIds.length===0 || roleArr.length===0){
          this.isShow=false
          return
        }
        let params={
          ids:roleArr.join(','),
          permIds:permIds.join(',')
        }
        addRolePermission(params).then(res=>{
          this.$Message.success('操作成功')
          this.$emit('done')
        }).catch(error=>{
        }).finally(()=>{
          this.isShow=false
        })
        //



      },
      cancel(){

      }
    }

  }
</script>

<style scoped>
  .content{
    height: 380px;
    /*overflow: auto;*/
  }
  .left,.right{
    height: 100%;
    overflow: auto;
  }
  .left{
    width: 200px;
    /*background: lightgray;*/
    border: 1px solid #dcdcdc;
    padding: 10px;
    box-sizing: border-box;
    margin-right: 20px;
  }

</style>
